/* eslint-disable import/no-anonymous-default-export */
import axios from 'axios';

import { config } from '../config';

const APIs = {
  AUTH: '/auth',
  LOGIN: '/auth/login',
  LOGOUT: '/auth/logout',
  ACCOUNTS: '/auth/accounts',
  USER_APP: '/users_app',
  WEB_CHAT: '/web-chat',
  SERVER_TIME: '/auth/server-time',
  CONG_NO: '/cong-no',
  // Proxy của backend tới bot TRA CỨU HÓA ĐƠN. KHÔNG gọi thẳng cổng 8100 của bot:
  // bot đòi header x-api-key (khóa chỉ được nằm ở backend) và chỉ nghe loopback trên
  // máy chủ nên trình duyệt không với tới.
  TRA_CUU: '/tra-cuu',
  // Kế toán chứng từ (backend :3010) — dùng để hỏi đơn đã có hồ sơ hóa đơn chưa.
  KT_CT: '/kt-ct',
};

async function login(values: any) {
  const { data } = await axios.post(APIs.LOGIN, values);
  return data;
}

async function logout() {
  const { data } = await axios.put(APIs.LOGOUT);
  return data;
}

async function getServerTime() {
  const { data } = await axios.get(APIs.SERVER_TIME);
  return data;
}

async function getUserProfile(token: string) {
  const { data } = await axios.get(`${APIs.AUTH}/profile`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
}

async function fetchDriverProfile(id: number) {
  const { data } = await axios.get(`${APIs.USER_APP}/detail`, {
    params: {
      id: id,
    },
  });
  return data;
}

async function fetchChatGroups(
  page: number,
  keyword: string,
  chatType: string,
  subChatType: string,
  ownerStatus: string,
  filterLabel: string = '',
  isChatOnly: boolean,
  itemsPerPage: number = 100,
  isShorten: boolean = false,
  filterLabelIds: string = '',
  onlyUnread: boolean = false,
) {
  const { data } = await axios.get(`${config.chatServerUrl}${APIs.WEB_CHAT}/groups`, {
    params: {
      page: page,
      itemsPerPage: itemsPerPage,
      keyword: keyword,
      chatType: chatType,
      subChatType: subChatType,
      ownerStatus: ownerStatus,
      isChatOnly: isChatOnly,
      shorten: isShorten,
      filterLabel: filterLabel,
      filterLabelIds: filterLabelIds,
      onlyUnread: onlyUnread ? 1 : 0,
    },
  });
  return data;
}

async function fetchChatGroupByID(id: number) {
  const { data } = await axios.get(`${config.chatServerUrl}${APIs.WEB_CHAT}/groups/${id}`);
  return data;
}

async function fetchChatUsersInGroup(id: number) {
  const { data } = await axios.get(`${config.chatServerUrl}${APIs.WEB_CHAT}/users/${id}`);
  return data;
}

async function fetchChatUsersInGroupV2(id: number) {
  const { data } = await axios.get(`${config.chatServerUrl}${APIs.WEB_CHAT}/v2/users/${id}`);
  return data;
}

async function fetchChatMessagesByToken(groupID: number, prevToken: string, itemsPerPage: number, botAi = '') {
  const { data } = await axios.get(`${config.chatServerUrl}${APIs.WEB_CHAT}/v2/messages/${groupID}`, {
    params: {
      prevToken,
      itemsPerPage,
      ...(botAi ? { botAi } : {}),
    },
  });
  return data;
}

async function forwardMessage(payload: any) {
  const { data } = await axios.post(`${config.chatServerUrl}${APIs.WEB_CHAT}/forward`, payload);
  return data;
}

async function searchChatGroups(keyword: string, page: number, chatType: string, subChatType: string) {
  const { data } = await axios.get(`${config.chatServerUrl}${APIs.WEB_CHAT}/groups/search`, {
    params: {
      keyword: keyword,
      chatType: chatType,
      subChatType: subChatType,
      page: page,
      itemsPerPage: 50,
    },
  });
  return data;
}

async function searchChatMessages(groupID: any, keyword: string, page: number) {
  const { data } = await axios.get(`${config.chatServerUrl}${APIs.WEB_CHAT}/messages/search`, {
    params: {
      groupId: groupID,
      keyword: keyword,
      page: page,
      itemsPerPage: 50,
    },
  });
  return data;
}

async function searchChatMembers(text: string) {
  const { data } = await axios.get(`${config.chatServerUrl}${APIs.WEB_CHAT}/search`, {
    params: {
      text: text,
    },
  });
  return data;
}

async function updateLastSeen(groupID: any) {
  const { data } = await axios.put(`${config.chatServerUrl}${APIs.WEB_CHAT}/groups/seen/${groupID}`);
  return data;
}

async function saveChatMessages(messages: any[]) {
  const { data } = await axios.post(`${config.chatServerUrl}${APIs.WEB_CHAT}/messages`, messages);
  return data;
}

// Đặt một lượt kiểm tra hồ sơ mới. Trả về NGAY (HTTP 202 phía bot) kèm bao_cao_url và
// job_id; lượt chạy thật mất khoảng 170 giây nên phải poll tiếp bằng fetchTraCuuJobStatus.
// lam_moi=1 = bỏ kết quả cũ, chạy lại từ đầu — chỉ gọi khi người dùng chủ động bấm nút.
/**
 * BẢNG ĐIỀU KIỆN TRA CỨU — nội dung popup HỒ SƠ HỢP ĐỒNG.
 *
 * Luật tính TRỌN ở máy chủ (`dieu-kien-tra-cuu.service.js`); màn hình chỉ vẽ lại.
 * Spec: `vic-desktop-app/prompts/22-tra-cuu-hoa-don.md` §2.
 */
async function getDieuKienTraCuu(maDonHang: string) {
  const { data } = await axios.get('/tra-cuu-ho-so/dieu-kien', {
    params: { ma_don_hang: maDonHang },
  });
  return data;
}

/**
 * ĐẶT LỆNH tra cứu, chạy nền. KHÔNG chờ bot (~170 giây).
 *
 * `nguon = 'CHAT'` là NƠI DUY NHẤT khiến máy chủ đăng tin nhắn báo cáo vào nhóm —
 * bấm từ bảng XUẤT HÓA ĐƠN hay cronjob thì chỉ ghi vào bảng lịch sử.
 */
async function datLenhTraCuu(values: { ma_don_hang: string; nguon: string; group_id?: string }) {
  const { data } = await axios.post('/tra-cuu-ho-so', values);
  return data;
}

/**
 * Đơn này đang có lệnh tra cứu CHỜ / ĐANG CHẠY không — khoá nút cho MỌI người trong
 * nhóm, không riêng người vừa bấm. `data[ma]` vắng mặt = không có lệnh.
 */
async function getTrangThaiTraCuu(maDonHang: string) {
  const { data } = await axios.get('/tra-cuu-ho-so/trang-thai-map', { params: { ma_don_hang: maDonHang } });
  return data;
}

/** Báo cáo MỚI NHẤT của một đơn — nguồn của nút XEM KIỂM TRA HĐ. */
async function getBaoCaoTraCuuMoiNhat(maDonHang: string) {
  const { data } = await axios.get('/tra-cuu-ho-so/moi-nhat', {
    params: { ma_don_hang: maDonHang },
  });
  return data;
}

async function traCuuHoaDon(maDonHang: string) {
  const { data } = await axios.get(`${APIs.TRA_CUU}/api/v1/tra-cuu`, {
    params: {
      ma_don_hang: maDonHang,
      lam_moi: 1,
    },
  });
  return data;
}

// Nội dung báo cáo — địa chỉ `noi_dung_url` trả về từ /api/v1/tra-cuu.
//
// Tài liệu TỰ CHỨA hoàn toàn (0 script, 0 link, 0 src, 0 href; CSS trong <style>, ảnh
// bằng data: URI) nên đổ thẳng vào tin nhắn là hiện đúng. Chạy chưa xong vẫn lấy được,
// phần đầu có khối tiến độ.
//
// Đi qua proxy backend chứ không gọi thẳng `noi_dung_url`: bot chỉ nghe loopback trên
// máy chủ nên trình duyệt người dùng không với tới được địa chỉ đó.
async function fetchTraCuuNoiDung(noiDungUrl: string, dang: 'html' | 'md' = 'html') {
  const u = new URL(noiDungUrl);
  const path = u.pathname.replace(/\.(html|md)$/i, '') + '.' + dang;
  const { data } = await axios.get(`${APIs.TRA_CUU}${path}${u.search}`, { timeout: 30000 });
  return data;
}

async function fetchTraCuuJobStatus(jobId: string) {
  const { data } = await axios.get(`${APIs.TRA_CUU}/api/v1/kiem-tra/${encodeURIComponent(jobId)}`);
  return data;
}

// Lượt TRA CỨU HÓA ĐƠN mới nhất của nhóm — nguồn cho nút XEM KIỂM TRA HĐ.
//
// Đọc từ TIN NHẮN đã lưu chứ không gọi lại bot: `/api/v1/tra-cuu` không kèm lam_moi chỉ
// dùng lại lượt cũ trong một khoảng ngắn, quá hạn là bot chạy lại từ đầu (~170 giây).
// `data = null` nghĩa là nhóm chưa từng tra cứu.
async function fetchTraCuuMoiNhat(groupId: number) {
  const { data } = await axios.get(`${config.chatServerUrl}${APIs.WEB_CHAT}/messages/tra-cuu-moi-nhat`, {
    params: { group_id: groupId },
  });
  return data;
}

// Ghi kết quả tra cứu xuống DB khi job xong. Không ghi thì lần sau mở lại nhóm tin nhắn
// sẽ kẹt ở màn hình chờ và phải poll lại từ đầu, mà job cũ có thể đã hết hạn.
async function updateHtmlMetadata(messageId: string, metadata: any) {
  const { data } = await axios.put(`${config.chatServerUrl}${APIs.WEB_CHAT}/messages/html-metadata`, {
    message_id: messageId,
    metadata,
  });
  return data;
}

async function updateChatGroup(payload: any) {
  const { data } = await axios.put(`${config.chatServerUrl}${APIs.WEB_CHAT}/groups`, payload);
  return data;
}

async function uploadChatFile(
  groupId: string,
  messageID: string,
  replyID: string,
  type: string,
  file: any,
  onUploadProgress: any,
) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('group_id', groupId);
  formData.append('message_id', messageID);
  formData.append('reply_id', replyID);
  formData.append('type', type);
  const { data } = await axios.post(`${config.chatServerUrl}${APIs.WEB_CHAT}/files`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress,
  });
  return data;
}

async function uploadChatFileV2(
  groupId: string,
  messageID: string,
  replyID: string,
  type: string,
  files: any[],
  message: string,
  onUploadProgress: any,
) {
  const formData = new FormData();
  for (let i = 0; i < files.length; i++) {
    formData.append('files', files[i]);
  }
  formData.append('group_id', groupId);
  formData.append('message_id', messageID);
  formData.append('reply_id', replyID);
  formData.append('type', type);
  if (message) {
    formData.append('message', message);
  }
  const { data } = await axios.post(`${config.chatServerUrl}${APIs.WEB_CHAT}/v2/files`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress,
  });
  return data;
}

async function uploadTransportChatFile(
  groupID: string,
  messageID: string,
  type: string,
  files: any[],
  onUploadProgress: any,
) {
  const formData = new FormData();
  for (let i = 0; i < files.length; i++) {
    formData.append('files', files[i]);
  }
  formData.append('group_id', groupID);
  formData.append('message_id', messageID);
  formData.append('type', type);
  const { data } = await axios.post(`${config.chatServerUrl}${APIs.WEB_CHAT}/v2/transport-images`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress,
  });
  return data;
}

async function createCommonDriverChat(id: number) {
  const { data } = await axios.post(`${config.chatServerUrl}${APIs.WEB_CHAT}/common-driver-chat`, {
    id,
  });
  return data;
}

async function removeChatMember(payload: any) {
  const { data } = await axios.post(`${config.chatServerUrl}${APIs.WEB_CHAT}/groups/remove-member`, payload);
  return data;
}

async function saveChatMessageReaction(id: number, reaction: string) {
  const { data } = await axios.put(`${config.chatServerUrl}${APIs.WEB_CHAT}/messages/react`, {
    id,
    reaction,
  });
  return data;
}

async function addChatMember(payload: any) {
  const { data } = await axios.post(`${config.chatServerUrl}${APIs.WEB_CHAT}/groups/add-member`, payload);
  return data;
}

// Đánh dấu đã đọc các nhóm chat của tab đang xem (chatType/subChatType/ownerStatus; rỗng = tất cả); trả về bộ đếm chưa đọc mới (cùng dạng /unread-by-group).
async function markAllChatSeen(chatType: string = '', subChatType: string = '', ownerStatus: string = '') {
  const { data } = await axios.put(
    `${config.chatServerUrl}${APIs.WEB_CHAT}/groups/seen-all`,
    {},
    {
      params: { chatType, subChatType, ownerStatus },
    },
  );
  return data;
}

async function fetchUnreadMessageCount() {
  const { data } = await axios.get(`${config.chatServerUrl}${APIs.WEB_CHAT}/unread-by-group`);
  return data;
}

async function deleteChatMessage(id: string) {
  const { data } = await axios.delete(`${config.chatServerUrl}${APIs.WEB_CHAT}/messages/${id}`);
  return data;
}

async function pinChatMessage(payload: any) {
  const { data } = await axios.post(`${config.chatServerUrl}${APIs.WEB_CHAT}/pin`, payload);
  return data;
}

async function unpinChatMessage(payload: any) {
  const { data } = await axios.post(`${config.chatServerUrl}${APIs.WEB_CHAT}/unpin`, payload);
  return data;
}

async function fetchPinnedChatMessages(groupID: any) {
  const { data } = await axios.get(`${config.chatServerUrl}${APIs.WEB_CHAT}/pin/${groupID}`);
  return data;
}

async function fetchQlHoTroOptions() {
  const { data } = await axios.get(APIs.ACCOUNTS, {
    params: {
      withoutHidden: true,
      withManagerFilter: true,
    },
  });
  return data;
}

async function createChatRequest(payload: any) {
  if (payload.type === 'req_empty_car') {
    const formData = new FormData();
    for (const key in payload) {
      if (key === 'files') {
        for (let i = 0; i < payload.files.length; i++) {
          formData.append(`file${i}`, payload.files[i]);
        }
      } else {
        formData.append(key, payload[key]);
      }
    }

    const { data } = await axios.put(`${config.chatServerUrl}${APIs.WEB_CHAT}/messages/request-data`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return data;
  } else {
    const { data } = await axios.put(`${config.chatServerUrl}${APIs.WEB_CHAT}/messages/request-data`, payload);
    return data;
  }
}

async function fetchCongNo(ownerID: string) {
  if (process.env.NODE_ENV === 'development') {
    return {
      success: true,
      data: [],
    };
  }
  const { data } = await axios.get(APIs.CONG_NO, {
    params: {
      ownerID,
    },
  });
  return data;
}

// Công nợ của NHIỀU đơn trong một request — dùng cho danh sách nhóm (xem utils/congNoStore.ts).
// Trả về `{ [owner_id]: [...] }`, đơn không có nợ thì mảng rỗng.
async function fetchCongNoBatch(ownerIDs: string[]) {
  if (process.env.NODE_ENV === 'development') {
    return {
      success: true,
      data: {},
    };
  }
  const { data } = await axios.get(`${APIs.CONG_NO}/batch`, {
    params: {
      ownerIDs: ownerIDs.join(','),
    },
  });
  return data;
}

async function fetchGroupPermissions() {
  const { data } = await axios.get(`${config.chatServerUrl}${APIs.WEB_CHAT}/group-permissions`);
  return data;
}

async function saveAIChatResponse(messages: any[]) {
  const { data } = await axios.post(`${config.chatServerUrl}${APIs.WEB_CHAT}/messages-ai`, messages);
  return data;
}

async function evaluateVicAIMessage(message_id: string, is_correct: boolean, reason?: string, suggestion?: string) {
  const { data } = await axios.post(`${config.chatServerUrl}${APIs.WEB_CHAT}/vicai/evaluate`, {
    message_id,
    is_correct,
    reason,
    suggestion,
  });
  return data;
}

/**
 * Đánh giá 👍 Đúng / 👎 Sai một tin của Trợ lý AI (nhóm `bot/new_ai`) — backend chính :3010.
 * Hợp đồng: agent_phan_viec docs/ke_hoach/HOP_DONG_API_CHAT_TRO_LY_AI.md §3. Đánh giá lại thì máy
 * chủ ghi thêm dòng mới và cập nhật `metadata.danh_gia` của tin.
 */
async function danhGiaTinTroLyAI(values: { message_id: string; gia_tri: 'dung' | 'sai'; ghi_chu?: string }) {
  const { data } = await axios.post('/tro-ly-ai/danh-gia-tin', values);
  return data;
}

async function getVicAIMessageEvaluation(message_id: string) {
  const { data } = await axios.get(`${config.chatServerUrl}${APIs.WEB_CHAT}/vicai/evaluations/${message_id}`);
  return data;
}

async function getVicAIAvailableBots() {
  const { data } = await axios.get(`${config.chatServerUrl}${APIs.WEB_CHAT}/vicai/available-bots`);
  return data;
}

// ===== Phân loại nhóm chat (chat conversation labels) =====

async function fetchChatLabels(chatType: string = '') {
  const { data } = await axios.get(`${config.chatServerUrl}${APIs.WEB_CHAT}/labels`, {
    params: { chatType },
  });
  return data;
}

async function createChatLabel(payload: { name: string; color: string; chatType: string }) {
  const { data } = await axios.post(`${config.chatServerUrl}${APIs.WEB_CHAT}/labels`, payload);
  return data;
}

async function updateChatLabel(id: number, payload: { name?: string; color?: string }) {
  const { data } = await axios.put(`${config.chatServerUrl}${APIs.WEB_CHAT}/labels/${id}`, payload);
  return data;
}

async function deleteChatLabel(id: number) {
  const { data } = await axios.delete(`${config.chatServerUrl}${APIs.WEB_CHAT}/labels/${id}`);
  return data;
}

async function reorderChatLabels(orderedIds: number[], chatType: string = '') {
  const { data } = await axios.put(`${config.chatServerUrl}${APIs.WEB_CHAT}/labels/reorder`, { orderedIds, chatType });
  return data;
}

async function assignChatLabel(labelId: number, groupId: number) {
  const { data } = await axios.post(`${config.chatServerUrl}${APIs.WEB_CHAT}/labels/assign`, { labelId, groupId });
  return data;
}

async function unassignChatLabel(labelId: number, groupId: number) {
  const { data } = await axios.post(`${config.chatServerUrl}${APIs.WEB_CHAT}/labels/unassign`, { labelId, groupId });
  return data;
}

async function fetchGroupLabels(groupId: number) {
  const { data } = await axios.get(`${config.chatServerUrl}${APIs.WEB_CHAT}/labels/group/${groupId}`);
  return data;
}

// Đơn này có hồ sơ để bot TRA CỨU HÓA ĐƠN chạy không.
//
// Trả về `{ available, ly_do, bo_ho_so }`. Điều kiện tính ở backend
// (`isHoaDonAvailable` trong ke-toan-chung-tu.service.js), khớp đúng dữ liệu mà
// `/vicai/ke-toan-chung-tu` dựng cho bot: phải có bản ghi HÓA ĐƠN XUẤT CHÍNH và bộ hồ sơ
// phải đính kèm ít nhất một tài liệu hợp đồng / hóa đơn / bảng kê.
async function isHoaDonAvailable(maDonHang: string) {
  const { data } = await axios.get(`${APIs.KT_CT}/is-hoa-don-available`, {
    params: { ma_don_hang: maDonHang },
  });
  return data;
}

export default {
  login,
  logout,
  getUserProfile,
  getServerTime,

  fetchDriverProfile,

  fetchChatGroups,
  fetchChatGroupByID,
  fetchChatUsersInGroup,
  fetchChatUsersInGroupV2,
  fetchChatMessagesByToken,
  forwardMessage,
  searchChatGroups,
  searchChatMessages,
  searchChatMembers,
  updateLastSeen,
  saveChatMessages,
  updateChatGroup,
  uploadChatFile,
  uploadChatFileV2,
  uploadTransportChatFile,
  createCommonDriverChat,
  removeChatMember,
  saveChatMessageReaction,
  addChatMember,
  fetchUnreadMessageCount,
  markAllChatSeen,
  deleteChatMessage,
  pinChatMessage,
  unpinChatMessage,
  fetchPinnedChatMessages,

  fetchQlHoTroOptions,
  createChatRequest,

  fetchCongNo,
  fetchCongNoBatch,

  traCuuHoaDon,
  getTrangThaiTraCuu,
  getDieuKienTraCuu,
  datLenhTraCuu,
  getBaoCaoTraCuuMoiNhat,
  isHoaDonAvailable,
  fetchTraCuuJobStatus,
  fetchTraCuuNoiDung,
  fetchTraCuuMoiNhat,
  updateHtmlMetadata,

  fetchGroupPermissions,

  saveAIChatResponse,

  evaluateVicAIMessage,
  danhGiaTinTroLyAI,
  getVicAIMessageEvaluation,
  getVicAIAvailableBots,

  fetchChatLabels,
  createChatLabel,
  updateChatLabel,
  deleteChatLabel,
  reorderChatLabels,
  assignChatLabel,
  unassignChatLabel,
  fetchGroupLabels,
};
